// extracted by mini-css-extract-plugin
module.exports = {"versionInput":"versionInput___1K-F7","FInputFSingleLine":"FInputFSingleLine___1LC3x","error":"error___1-hvM","noEdit":"noEdit___3iCWQ"};